export { default } from '../Success';



// WEBPACK FOOTER //
// ./src/give/AddAccount/Success.js